// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumbs_breadcrumb__BrYAu","active":"Breadcrumbs_active__mlPjQ"};